import { Box, CircularProgress, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

interface IBlurBackdropProps {
  open: boolean;
  children: ReactNode;
  backdropContent?: ReactNode;
  backdropSx?: SxProps<Theme>;
}

const BlurBackdrop = ({
  open,
  children,
  backdropContent = <CircularProgress color='primary' />,
  backdropSx,
}: IBlurBackdropProps) => {
  return open ? (
    <div className='relative'>
      <div className='relative blur-sm'>{children}</div>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backdropFilter: 'blur(3px)',
          zIndex: 1,
          ...backdropSx,
        }}
      >
        {backdropContent}
      </Box>
    </div>
  ) : (
    children
  );
};

export default BlurBackdrop;
